import { onViewChange, allToTallest } from '@/resources/assets/js/modules/utils';

class HeaderHero {

  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.cardsSupport = [...this.root.querySelectorAll('.Card > p')];
    this.dropdownController = this.root.querySelector('.HeaderHero-questions p');
    this.dropdown = this.root.querySelector('.HeaderHero-questions ul');
    this.#init();
  }

  #init() {
    if (window.innerWidth < 992 || this.cardsSupport.length == 0) return;
    allToTallest(this.cardsSupport);
    onViewChange(allToTallest.bind(this, this.cardsSupport));

    this.dropdownController.addEventListener('click', this.#toggleDropdown.bind(this));
  }

  #toggleDropdown() {
    this.dropdown.classList.toggle('active');
    this.dropdownController.classList.toggle('active');
  }
}

[...document.querySelectorAll('.HeaderHero')].forEach(node => {
  new HeaderHero(node);
});